const stickyHeader = {
    header: document.getElementById('jsStickyHeader'),
    mainContent: document.getElementById('mainContent'),
    user: document.getElementById('jsUserWrap'),
    cart: document.getElementById('jsCartWrap'),
    mobMenu: document.getElementById('jsMenuWrap'),
    mobSearch: document.getElementById('jsSearchWrap'),
    lastScrollTop: 0,

    init() {
        this.setClass();
        this.activeClass();

    },

    setClass() {

        document.addEventListener('scroll', (e) => {
            let st = window.scrollY || document.documentElement.scrollTop;
            if (st > this.lastScrollTop) {
                this.header.classList.remove('up');
                this.header.classList.add('down');
                this.mainContent.classList.remove('up');
                this.mainContent.classList.add('down');
                this.user.classList.add('activeScroll')
                this.cart.classList.add('activeScroll')
                this.mobMenu.classList.add('activeScroll')
                this.mobSearch.classList.add('activeScroll')


            } else {
                this.header.classList.add('up');
                this.header.classList.remove('down');
                this.mainContent.classList.add('up');
                this.mainContent.classList.remove('down');
                this.user.classList.add('activeScroll')
                this.cart.classList.add('activeScroll')
                this.mobMenu.classList.add('activeScroll')
                this.mobSearch.classList.add('activeScroll')

            }
            this.lastScrollTop = st <= 0 ? 0 : st;

            if (window.scrollY === 0) {
                this.header.classList.remove('up');
                this.header.classList.remove('down');
                this.mainContent.classList.remove('up');
                this.mainContent.classList.remove('down');
                this.user.classList.remove('activeScroll');
                this.cart.classList.remove('activeScroll');
                this.mobMenu.classList.remove('activeScroll')
                this.mobSearch.classList.remove('activeScroll')

            }

        })
    },

    activeClass() {
        const activeLink = document.querySelectorAll('.jsLvl1');
        activeLink.forEach(button => {
            button.addEventListener('click', function () {
                activeLink.forEach(btn => btn.classList.remove('activeClass'));
                this.classList.add('activeClass');
            });
        });
    },





}

export default stickyHeader;